export default __webpack_public_path__ + "static/media/independent-retailers.319511d3.png";